import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "flex-fill text-truncate" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = {
  key: 1,
  class: "mt-2 mb-3 text-muted"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = [".usernameIndex"]
const _hoisted_8 = {
  key: 1,
  class: "mt-2 mb-3 text-muted"
}

import {onBeforeUnmount, onMounted, ref, computed, watch, getCurrentInstance} from 'vue';
import {BuddyListGroupInterface} from "~/operatorApplication/vue/dialogs/buddyList/group/BuddyListInterface";
import BuddyListItem from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItem.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {
    APP_ICON_BADGE_TYPE_MESSAGES,
    OperatorApplicationConfigInstance
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import VueIntersect from "~/core-ui/vue/VueIntersect.vue";
import Dictionary from "~/ts/library/Dictionary";
import {Intervals} from "~/ts/library/delay/Intervals";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {
    OperatorApplicationEventManager,
    SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {__} from "~/ts/library/Translate";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import BuddyListItemContextMenu from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemContextMenu.vue";
import HiddenClientCountTooltip from "~/operatorApplication/vue/dialogs/buddyList/group/HiddenClientCountTooltip.vue";
import {useRawComponent} from "~/core-ui/ts/useRawComponent";
import DialogOfOperatorTooltip from "~/operatorApplication/vue/dialogs/buddyList/group/DialogOfOperatorTooltip.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import ObjectHelper from "~/ts/library/ObjectHelper";


const __default__ = {
    name: "BuddyListGroup"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    scrollContainer: {},
    buddyList: {},
    group: {},
    emptyPlaceholder: {},
    collapsed: { type: Boolean },
    isFilterModeEnabled: { type: Boolean },
    selectedUsername: {},
    unavailableBecauseOfFree: { type: Boolean },
    selectedOperatorIds: {}
  },
  emits: ["update:collapsed", "select", "reload"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

//let contextMenuRef = ref<ContextMenuExposeInterface>();

let emits = __emit;
/*
 previousUsernames: [],
        heightByUsername: {}
 */

let heightByUsername = ref<Dictionary<number>>({});
let previousUsernames: Dictionary<boolean> = {};
let firstIntersected = ref<number>();
let lastIntersected = ref<number>();
let intersectObserver = ref<IntersectionObserver>();
let showHidden = ref(false);
let selectedUsernameExistInList = ref(true);

let currentInstance = getCurrentInstance().proxy;


initIntersectObserver();
addDisposableEvent(Intervals.setDisposable(() => {
    clearBuddyList();
}, 10000));

let contextMenu = ref<{
    username: string,
    event: MouseEvent,
    visible: boolean
}>();

function openContextMenu(username: string, event: MouseEvent) {
    contextMenu.value = {
        username,
        event,
        visible: true
    }
}

function clearBuddyList() {
    if (props.buddyList.isMainBuddyList) {
        if (OperatorAccountStore.hasNonFreeSites) {
            if (OperatorApplicationConfigInstance.autoClearBuddyListEnabled || OperatorApplicationConfigInstance.autoClearClosedDialogsBuddyListEnabled) {
                let toRemove = [];
                let minTimestamp = (Date.now() / 1000) - OperatorApplicationConfigInstance.autoClearBuddyListDelay;
                for (let username of usernames.value) {
                    if (username !== props.selectedUsername) {
                        let client = ClientUserdataStore.getByUsername(username, false);
                        if (client) {
                            if (!client.isHaveNoAnswer && !client.isPinned) {
                                if (!client.unreadedMessageIds.length) {
                                    if (OperatorApplicationConfigInstance.autoClearBuddyListEnabled) {
                                        let lastActivityTimestamp = ClientUserdataStore.getClientLastActivityTimestamp(username);
                                        let lastMessageTime = client.lastMessage ? client.lastMessage.dateTime : 0;
                                        let lastActivity = Math.max(
                                            lastActivityTimestamp ? lastActivityTimestamp : 0,
                                            lastMessageTime
                                        );
                                        if (lastActivity > 0) {
                                            if (lastActivity < minTimestamp) {
                                                toRemove.push(username);
                                                continue;
                                            }
                                        }
                                    }
                                    if (OperatorApplicationConfigInstance.autoClearClosedDialogsBuddyListEnabled) {
                                        if (!getCurrentDialogOfClient(client)) {
                                            toRemove.push(username);
                                        }
                                    }

                                } else {
                                    ClientUserdataStore.setClientLastActivityTimestamp(username);
                                }
                            }
                        }
                    }
                }
                if (toRemove.length) {
                    OperatorApplicationBuddyList.removeClients(toRemove);
                }
            }
        }
    }
}


onMounted(() => {
    setCollapsed(props.collapsed);
});

onBeforeUnmount(() => {
    for (let username of usernames.value) {
        ClientUserdataStore.unsubscribe(username, props.buddyList, currentInstance);
    }
    intersectObserver.value.disconnect();
    intersectObserver.value = null;
});

let showDialogCount = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewOperatorDialogCount;
});

function checkListInViewport() {
    let result = true;
    if (firstIntersected.value !== null) {
        let rect = currentInstance.$el.getBoundingClientRect();
        if (
            rect.top * -1 > (currentInstance.$el as HTMLElement).offsetHeight
            ||
            rect.top > props.scrollContainer.offsetHeight
        ) {
            result = false;
        }
    }
    return result;
}

function initIntersectObserver() {
    let minIndex: number = null;
    let maxIndex: number = null;
    let applyTimeout: any;
    let checkListInViewportTimeout: any;
    let currentVisible: number[] = [];
    intersectObserver.value = new IntersectionObserver((entries) => {

        /*
        if (minIndex !== null && maxIndex !== null) {
            for (let i = minIndex; i <= maxIndex; i++) {
                currentVisible.push(i);
            }
        }
        */
        for (let entry of entries) {
            //if (entry.target.parentElement) {
            let index = parseInt((entry.target as any).usernameIndex);
            let fake = entry.target.classList.contains("fake");
            if (!fake) {
                let username = usernames.value[index];
                if (username) {
                    let height = parseInt(entry.boundingClientRect.height.toString());
                    if (height > 0 && height != heightByUsername.value[username]) {
                        heightByUsername.value[username] = height;
                    }
                }
            }
            if (entry.isIntersecting) {
                //currentVisible.push(index);
                toggleArrayElement(currentVisible, index, true);
            } else {
                toggleArrayElement(currentVisible, index, false);
            }
            //}
        }
        if (currentVisible.length) {
            maxIndex = Math.max(...currentVisible);
            minIndex = Math.min(...currentVisible);
        } else {
            maxIndex = null;
            minIndex = null;
        }


        let timeoutDelay = 1;
        if (maxIndex < minIndex) {
            maxIndex = minIndex;
        }

        let delta = maxIndex - minIndex;

        if (delta > 30) {
            clearTimeout(applyTimeout);
            applyTimeout = null;
            timeoutDelay = 150;
        }


        if (!applyTimeout) {
            applyTimeout = setTimeout(() => {
                applyTimeout = null;
                //console.log(maxIndex - minIndex);
                if (setIntersected(minIndex, maxIndex)) {
                    clearTimeout(checkListInViewportTimeout);
                    checkListInViewportTimeout = setTimeout(() => {
                        if (!checkListInViewport()) {
                            setIntersected(0, 0);
                            minIndex = maxIndex = 0;
                        }
                    }, 1000);
                }
            }, timeoutDelay);
        }
    }, {
        threshold: 0.000001,
        root: props.scrollContainer
    });
}


function setIntersected(minIndex?: number, maxIndex?: number) {
    let changed = false;
    if (minIndex !== firstIntersected.value) {
        firstIntersected.value = minIndex;
        if (minIndex != null) {
            changed = true;
        }
    }
    if (maxIndex !== lastIntersected.value) {
        lastIntersected.value = maxIndex;
        if (maxIndex != null) {
            changed = true;
        }
    }
    return changed;
}


function isIntersected(index: number) {
    if (firstIntersected.value !== null && lastIntersected.value !== null && !props.collapsed) {
        return index >= firstIntersected.value - 3 && index <= lastIntersected.value + 3;
    }
    return false;
}

function setCollapsed(value: boolean) {
    emits("update:collapsed", value);
}

let clientCount = computed(() => {
    return props.group.getCountMethod();
});

let isShowHiddenComputed = computed(() => {
    return showHidden.value || !props.buddyList.isCustomSearchList;
});

let hiddenClientCount = computed(() => {
    let result = 0;
    if (props.buddyList.isCustomSearchList) {
        for (let username of usernames.value) {
            let client = ClientUserdataStore.getByUsername(username, false);
            if (client && client.isHiddenForOperator) {
                result++;
            }
        }
    }
    return result;
});

let usernames = computed(() => {
    return props.group.getUsernamesMethod();
});

watch(usernames, (newUsernames: string[]) => {
    let newUsernamesDictionary: Dictionary<boolean> = {};
    for (let username of newUsernames) {
        newUsernamesDictionary[username] = true;
        if (!previousUsernames[username]) {
            ClientUserdataStore.subscribe(username, props.buddyList, currentInstance);
        }
    }
    for (let username in previousUsernames) {
        if (previousUsernames.hasOwnProperty(username)) {
            if (!newUsernamesDictionary[username]) {
                delete heightByUsername.value[username];
                ClientUserdataStore.unsubscribe(username, props.buddyList, currentInstance);
            }
        }
    }
    previousUsernames = newUsernamesDictionary;
}, {
    deep: true,
    immediate: true
});

watch(computed(() => props.selectedUsername), username => {
    if (username) {
        selectedUsernameExistInList.value = !!previousUsernames[username];
    }
});

let unreadedCount = computed(() => {
    let result = 0;
    for (let username of usernames.value) {
        let client = ClientUserdataStore.getByUsername(username, false);
        let count = client?.unreadedMessageIds.length ?? 0;
        if (count > 0) {
            if (OperatorApplicationConfigInstance.buddyListBadgeType == APP_ICON_BADGE_TYPE_MESSAGES) {
                result += count;
            } else {
                result++;
            }
        }
    }
    return result;
});

let showOperators = computed(() => {
    return OperatorApplicationConfigInstance.buddyListShowOperators;
});

let operatorsFromYourGroup = computed<Dictionary<true>>(() => {
    let result: Dictionary<true> = {};
    let siteId = props.group.siteId;
    let sites = siteId ? [OperatorAccountStore.sitesDictionary.value[siteId]] : OperatorAccountStore.data.value.sites;
    for (let site of sites) {
        if (site) {
            for (let group of site.groups) {
                if (group.operators.includes(OperatorAccountStore.operator.value.login)) {
                    for (let login of group.operators) {
                        result[login] = true;
                    }
                }
            }
        }
    }
    return ObjectHelper.hasKeys(result) ? result : undefined;
})

let operators = computed(() => {
    if (showOperators.value && props.group.operators) {
        let result = props.group.operators.filter(operatorLogin => {
            let operator = OperatorAccountStore.operatorsDictionary.value[operatorLogin];
            let statusId = getOperatorStatus(operator).statusId;
            let result = operator && statusId != OPERATOR_STATUS_OFFLINE && operator.isWorkingNow;
            if (result && OperatorApplicationConfigInstance.buddyListShowOperatorsOfYourGroupOnly) {
                if (operatorsFromYourGroup.value) {
                    result = !!operatorsFromYourGroup.value[operator.login];
                }
            }
            return result;
        }).map(operatorLogin => {
            return OperatorAccountStore.operatorsDictionary.value[operatorLogin];
        }).sort((a, b) => {
            if (a.fio == b.fio) {
                return 0;
            }
            return a.fio > b.fio ? 1 : -1;
        });
        if (result.length) {
            return result;
        }
    }
    return null;
});

function getOperatorStatus(operator: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel) {
    return OperatorAccountStore.getOperatorStatus(operator.login, props.group.siteId);
}

function getCustomStatusColorByOperator(operator: OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel) {
    let status = getOperatorStatus(operator);
    let result: string = null;
    if (status.customStatusId) {

        let customStatus = OperatorAccountStore.customStatusDictionary.value[status.customStatusId];
        if (customStatus) {
            result = customStatus.color;
        }
    }
    return result;
}

watch(computed(() => props.selectedUsername), () => {
    if (OperatorApplicationConfigInstance.autoClearClosedDialogsBuddyListEnabled) {
        clearBuddyList();
    }
});

let canViewChatsWithOtherOperators = computed(() => {
    return OperatorAccountStore.data.value.accessRights.canViewChatsWithOtherOperators;
});

function selectOperator(id: string) {
    OperatorApplicationEventManager.emit(SELECT_OPERATOR_FOR_ANOTHER_OPERATORS_DIALOG, id);
}



return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'buddy-list-group': true,
            collapsed: __props.collapsed
        })
  }, [
    (__props.group.descr && (!__props.group.hideTitle || _unref(hiddenClientCount) > 0))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "title pt-2 pb-2 sticky -top",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setCollapsed(!__props.collapsed)))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(FontAwesomeIcon, {
                class: "collapse-icon",
                icon: "chevron-down"
              }),
              (!__props.group.dialogState)
                ? _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
                    key: 0,
                    class: "mr-1 ml-1",
                    icon: "flag-checkered"
                  }, null, 512)), [
                    [_directive_my_tooltip, _unref(__)('Завершённые диалоги')]
                  ])
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(__props.group.descr), 1)
            ]),
            (_unref(clientCount))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  size: "small",
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    (_unref(hiddenClientCount))
                      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                          key: 0,
                          icon: "eye",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(clientCount) - _unref(hiddenClientCount)), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_my_tooltip, _unref(__)('Количество посетителей')]
                ])
              : _createCommentVNode("", true),
            (_unref(hiddenClientCount))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  size: "small",
                  type: _unref(showHidden) ? 'purple' : 'info',
                  class: _normalizeClass({'cursor-pointer': true, 'ml-2': true})
                }, {
                  default: _withCtx(() => [
                    _createVNode(FontAwesomeIcon, {
                      icon: "eye-slash",
                      class: "mr-1"
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(hiddenClientCount)), 1)
                  ]),
                  _: 1
                }, 8, ["type"])), [
                  [_directive_my_tooltip, {component: _unref(useRawComponent)(HiddenClientCountTooltip), props: {showHidden: _unref(showHidden)}, placement: 'right'}],
                  [
                    _directive_on_native,
                    () => _isRef(showHidden) //@ts-ignore
 ? showHidden.value = !_unref(showHidden) : showHidden = !_unref(showHidden),
                    "click",
                    { stop: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!_unref(clientCount) || _unref(unreadedCount))
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  class: _normalizeClass({
                        'visibility-hidden': _unref(unreadedCount) === 0,
                        'ml-2': _unref(clientCount) > 0
                    }),
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(unreadedCount)), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ]),
          (_unref(operators))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
                  return _withDirectives((_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                    key: operator.id,
                    class: _normalizeClass({
                        'mt-2 mr-2 operator-avatar': true,
                        'not-selected': Array.isArray(__props.selectedOperatorIds) && __props.selectedOperatorIds.length && !__props.selectedOperatorIds.includes(operator.id),
                        'selectable': _unref(canViewChatsWithOtherOperators)
                    }),
                    operator: operator,
                    "status-id": getOperatorStatus(operator).statusId,
                    "status-color": getCustomStatusColorByOperator(operator),
                    "show-dialog-count": _unref(showDialogCount),
                    "site-id": __props.group.siteId
                  }, null, 8, ["class", "operator", "status-id", "status-color", "show-dialog-count", "site-id"])), [
                    [_directive_my_tooltip, {
                        delay: 300,
                        component: _unref(useRawComponent)(DialogOfOperatorTooltip),
                        props: {
                            operator: operator,
                            canViewChatsWithOtherOperators: _unref(canViewChatsWithOtherOperators)
                        }
                    }],
                    [
                      _directive_on_native,
                      () => selectOperator(operator.id),
                      "click",
                      { stop: true }
                    ]
                  ])
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_unref(contextMenu))
        ? (_openBlock(), _createBlock(BuddyListItemContextMenu, {
            key: 0,
            visible: _unref(contextMenu).visible,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(contextMenu).visible) = $event)),
            "buddy-list": __props.buddyList,
            event: _unref(contextMenu).event,
            username: _unref(contextMenu).username,
            "another-operator-buddy-list": _unref(props).buddyList.isAnotherOperatorBuddyList ? {
                    selectedOperatorIds: _unref(props).selectedOperatorIds,
                    reload: () => _unref(emits)('reload', false)
                } : undefined
          }, null, 8, ["visible", "buddy-list", "event", "username", "another-operator-buddy-list"]))
        : _createCommentVNode("", true),
      (__props.unavailableBecauseOfFree)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(__)("Недоступно в бесплатной версии")), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_unref(usernames).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usernames), (username, index) => {
                    return (_openBlock(), _createBlock(VueIntersect, {
                      key: username,
                      observer: _unref(intersectObserver)
                    }, {
                      default: _withCtx(() => [
                        (isIntersected(index))
                          ? _withDirectives((_openBlock(), _createBlock(BuddyListItem, {
                              "group-site-id": __props.group.siteId,
                              ".usernameIndex": index,
                              key: `${username}-intersected`,
                              username: username,
                              selected: username === __props.selectedUsername,
                              "buddy-list": __props.buddyList,
                              "show-hidden": _unref(isShowHiddenComputed),
                              class: _normalizeClass(`buddy-list-item buddy-list-item-${username}`),
                              onClick: ($event: any) => (_unref(emits)('select', username)),
                              "selected-username-exist-in-list": _unref(selectedUsernameExistInList)
                            }, null, 40, ["group-site-id", ".usernameIndex", "username", "selected", "buddy-list", "show-hidden", "class", "onClick", "selected-username-exist-in-list"])), [
                              [
                                _directive_on_native,
                                (event) => openContextMenu(username, event),
                                "contextmenu",
                                { prevent: true }
                              ]
                            ])
                          : (_openBlock(), _createElementBlock("div", {
                              key: username,
                              ".usernameIndex": index,
                              class: _normalizeClass(`buddy-list-item fake buddy-list-item-${username}`),
                              style: _normalizeStyle({height: (_unref(heightByUsername)[username] ? _unref(heightByUsername)[username] : 80) + 'px'})
                            }, null, 46, _hoisted_7))
                      ]),
                      _: 2
                    }, 1032, ["observer"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (__props.emptyPlaceholder && ((_unref(usernames).length <= _unref(hiddenClientCount) && !_unref(showHidden)) || !_unref(usernames).length))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.emptyPlaceholder), 1))
              : _createCommentVNode("", true)
          ], 64))
    ])
  ], 2)), [
    [_vShow, !__props.isFilterModeEnabled || _unref(usernames).length]
  ])
}
}

})